import { Type } from '@angular/core'

export class QuestionItem {
  constructor(
    public component: Type<any>,
    public question: any,
    public response: any
  ) {}
}
